"use strict";




// ЛОГИКА ВИЗУАЛЬНОГО УДАЛЕНИЯ ЭЛЕМЕНТОВ ИЗ КОРЗИНЫ

let delete_item_buttons = document.querySelectorAll('.delete-item-buttons');

for (let button of delete_item_buttons) {
    button.addEventListener("click", function () {
        let entire_item = button.closest('tr');
        entire_item.classList.add("delete-item-1");
        setTimeout(() => {
            entire_item.classList.add("delete-item-2");



            let xhr = new XMLHttpRequest();
            xhr.open("POST", "/cart/update.js");


            let request = JSON.stringify({
                updates: {
                    [entire_item.dataset.id]: 0
                }
            });

            xhr.setRequestHeader('Content-type', 'application/json; charset=utf-8');
            xhr.send(request);

        }, 1000);
    });
}



// ЛОГИКА ИЗМЕНЕНИЯ КОЛИЧЕСТВА ВЫБРАННЫХ ТОВАРОВ

let product_counters = document.querySelectorAll('.product_count');
for (let counter of product_counters) {

    let counter_input = counter.querySelector('.input-text');
    let counter_increase = counter.querySelector('.increase');
    let counter_reduce = counter.querySelector('.reduced');
    let entire_item = counter.closest('tr');

    counter_increase.addEventListener('click', function () {
        counter_input.value = +(counter_input.value) + 1;


        // ЗАПРОС НА ИЗМЕНЕНИЕ ДАННЫХ О КОЛИЧЕСТВЕ

        let xhr = new XMLHttpRequest();
        xhr.open("POST", "/cart/update.js");
        let request = JSON.stringify({
            updates: {
                [entire_item.dataset.id]: counter_input.value
            }
        });
        xhr.setRequestHeader('Content-type', 'application/json; charset=utf-8');
        xhr.send(request);
    });











    counter_reduce.addEventListener('click', function () {
        if (+counter_input.value == 1) {
            return;
        }
        else {
            counter_input.value = +(counter_input.value) - 1;


            // ЗАПРОС НА ИЗМЕНЕНИЕ ДАННЫХ О КОЛИЧЕСТВЕ

            let xhr = new XMLHttpRequest();
            xhr.open("POST", "/cart/update.js");
            let request = JSON.stringify({
                updates: {
                    [entire_item.dataset.id]: counter_input.value
                }
            });
            xhr.setRequestHeader('Content-type', 'application/json; charset=utf-8');
            xhr.send(request);
        }
    });

}





